import {Selectors} from '../Settings';
import Testimonials from '../Elements/Testimonials';
import Thumbnails from '../Elements/Thumbnails';

class TestimonialController {
  constructor() {
    this.initializeElements();
  }

  initializeElements() {
    this.initializeElement(Selectors.thumbnails, Thumbnails);
    this.initializeElement(Selectors.testimonialsWrap, Testimonials);
  }

  initializeElement(elementSelector, elementClass) {
    let $element = $(elementSelector);
    if ($element.length > 0) {
      new elementClass($element);
    }
  }
}

export default TestimonialController;
